import { For, Show } from 'solid-js';
import { Slider } from '../../../ui-components/slider/slider';
import { Text } from '../../../ui-components/text/text';
import { ProductVideoData } from './product-video-types';
import removeAmpersand from '../../../tools/remove-ampersand';
import { VideoPostCard } from '../../videos/video-post-card/video-post-card';

/* Figma "products single" 173:10758: copy column capped at the DS sidebar-lg width beside a
   framed 16:9 player, ds-gap(7) between them; ds-space(10) between title and body. Stacks
   below the tablet-original breakpoint. */
export const ProductVideo = (props: ProductVideoData) => {
    return (
        <div class="pt-cvi-section-default">
            <div class="flex flex-col gap-cvi-8 tablet-original:flex-row tablet-original:items-start">
                <div class="flex w-full flex-col gap-cvi-10 tablet-original:flex-1 tablet-original:max-w-cvi-sidebar-lg tablet-original:pr-cvi-8">
                    <h2 class="m-0 heading-3xl font-cvi-medium text-cvi-fg-default">
                        {removeAmpersand(props.videoData?.title)}
                    </h2>
                    <Text fontSize="body-md" noBlockSpacing>
                        {props.videoData?.description}
                    </Text>
                </div>
                <div class="flex w-full min-w-0 flex-col tablet-original:flex-1">
                    <Show when={props.videoData?.videos?.length}>
                        <Slider slidesPerView={1} slideHeight="auto">
                            <For each={props.videoData?.videos}>{(video) => (
                                <VideoPostCard
                                    title={video.title}
                                    videoUrl={video.url}
                                    inGrouping={false}
                                    isHealthcareProfessional={false}
                                    ableToPlay={true}
                                    isVisibleForPublic={true}
                                    permalink={''}
                                    hideMyContentStar={true}
                                    mediaOnly={true}
                                />
                            )}</For>
                        </Slider>
                    </Show>
                </div>
            </div>
        </div>
    );
};
